import React from "react";
import {cn} from "../utils";

const FocusIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
         height="512"
         width="512"
         viewBox="0 0 24 24"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="m16.4444 1.25c-.4142 0-.75.33579-.75.75s.3358.75.75.75zm-8.88884 1.5c.41421 0 .75-.33579.75-.75s-.33579-.75-.75-.75zm13.69444 4.80556c0 .41421.3358.75.75.75s.75-.33579.75-.75zm1.5 8.88884c0-.4142-.3358-.75-.75-.75s-.75.3358-.75.75zm-6.3056 4.8056c-.4142 0-.75.3358-.75.75s.3358.75.75.75zm-8.88884 1.5c.41421 0 .75-.3358.75-.75s-.33579-.75-.75-.75zm-6.30556-15.19444c0 .41421.33579.75.75.75s.75-.33579.75-.75zm1.5 8.88884c0-.4142-.33579-.75-.75-.75s-.75.3358-.75.75zm13.6944-13.6944h1.5556v-1.5h-1.5556zm-10.4444 0h1.55556v-1.5h-1.55556zm15.25 3.25v1.55556h1.5v-1.55556zm0 10.4444v1.5556h1.5v-1.5556zm-3.25 4.8056h-1.5556v1.5h1.5556zm-10.44444 0h-1.55556v1.5h1.55556zm-4.80556-13.69444v-1.55556h-1.5v1.55556zm0 10.44444v-1.5556h-1.5v1.5556zm3.25 3.25c-1.79493 0-3.25-1.4551-3.25-3.25h-1.5c0 2.6234 2.12665 4.75 4.75 4.75zm15.25-3.25c0 1.7949-1.4551 3.25-3.25 3.25v1.5c2.6234 0 4.75-2.1266 4.75-4.75zm-3.25-15.25c1.7949 0 3.25 1.45507 3.25 3.25h1.5c0-2.62335-2.1266-4.75-4.75-4.75zm-12-1.5c-2.62335 0-4.75 2.12665-4.75 4.75h1.5c0-1.79493 1.45507-3.25 3.25-3.25zm10.25 10.75c0 2.3472-1.9028 4.25-4.25 4.25v1.5c3.1756 0 5.75-2.5744 5.75-5.75zm-4.25 4.25c-2.34721 0-4.25-1.9028-4.25-4.25h-1.5c0 3.1756 2.57436 5.75 5.75 5.75zm-4.25-4.25c0-2.34721 1.90279-4.25 4.25-4.25v-1.5c-3.17564 0-5.75 2.57436-5.75 5.75zm4.25-4.25c2.3472 0 4.25 1.90279 4.25 4.25h1.5c0-3.17564-2.5744-5.75-5.75-5.75z"
            fill={color || "currentColor"}
        />
    </svg>
);

export {FocusIcon};